import { useRef, useSyncExternalStore } from 'react'
import { ISignal } from '@/utils/signals'

/** Helper hook to keep your React component in sync with a signal */
export function useSyncSignal<T>(signal: ISignal<T>, initial: T) {
  const value = useRef<T>(initial)
  return useSyncExternalStore<T>(callback => {
    const updateValue = (newValue: T) => {
      value.current = newValue
      callback()
    }
    signal.connect(updateValue)
    return () => signal.disconnect(updateValue)
  }, () => value.current)
}
